module.exports = " <app-navmenu>\r\n\r\n</app-navmenu>\r\n<app-login>\r\n\r\n</app-login>"